module.exports = __webpack_public_path__ + "static/media/upload_OMR.d355bfcc.png";